import { SideNav } from "shared/Components/sidenav";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { globalVariables } from "helper/globalVariables";
import {
  AdminDashboard,
  ManageUsers,
  ManangeDogs,
  ManangeGallery as ManageGalleryIcon,
  Payments as PaymentIcon,
  JudgeUser,
  GenerateReports,
  SwitchRole,
  Host,
} from "helper/images";
import { Magnifier } from "helper/icons";
import { RefineAdmin } from "admin/RefineAdmin";

import { globalClasses } from "helper/globalClasses";

import Payments from "container/SuperAdmin/Payments";
import { MobileHeader } from "shared/Components/mobileHeader";
import ManageTrail from "container/SuperAdmin/TrailManagement";
import SuperAdminDashboard from "container/SuperAdmin/Dashboard";
import GenerateReportsScreen from "container/SuperAdmin/ReportsManagement";

import { ManageUsers as ManageUsersScreen } from "container/SuperAdmin/ManageUsers";
import { UserDetail } from "container/SuperAdmin/UserDetail";
import { AddDogHistory } from "container/SuperAdmin/ManageDogs/AddDogHistory";
import { DetailsOfDog } from "container/SuperAdmin/ManageDogs/DetailsOfDogs";
import { EditDogProfile } from "container/SuperAdmin/ManageDogs/EditDogProfile";
import { AdminDogHistory } from "container/SuperAdmin/ManageDogs/AdminDogHistory";
import { ManageTrailDetails } from "container/SuperAdmin/TrailManagement/components/ManageTrailDetails";
import ManageGallery from "container/SuperAdmin/ManageGallery";
import EditAbleProfiles from "container/SuperAdmin/EditAbleProfiles";
import { LoaderProvider } from "container/MyProfile/Context/EditAndLoaderContext";
import { RoleTabProvider } from "context/RoleTabsContext";
import { MyProfile } from "container/MyProfile";
import { AddTrial } from "container/Host/AddTrial";
import { ViewJudges } from "container/Host/ViewJudges";
import { ViewAllHosts } from "container/Host/HostATrial";
import { ManageTrailDetailsReports } from "container/SuperAdmin/ReportsManagement/components/ManageTrailDetails";

export const SuperAdminRoutes = () => {
  const { menuIcon } = globalClasses;

  const sideNavData = [
    {
      icon: <AdminDashboard className={menuIcon} />,
      label: globalVariables.adminDashboard,
      navigate: "/admin/dashboard",
    },
    {
      icon: <ManangeDogs className={menuIcon} />,
      label: globalVariables.manageDogs,
      navigate: "/admin/manage/dogs",
      active: "/admin/manage/dogs/dogHistory?option=switchRole",
    },
    {
      icon: <JudgeUser className={menuIcon} />,
      label: globalVariables.viewJudges,
      navigate: "/admin/viewJudges",
    },
    {
      icon: <Host className={menuIcon} />,
      label: globalVariables.viewHosts,
      navigate: "/admin/viewHosts",
    },
    {
      icon: <ManageUsers className={menuIcon} />,
      label: globalVariables.manageUsers,
      navigate: "/admin/manage/users",
    },
    {
      icon: <PaymentIcon className={menuIcon} />,
      label: globalVariables.payments,
      navigate: "/admin/payments",
    },
    {
      icon: <ManageGalleryIcon className={menuIcon} />,
      label: globalVariables.manageGallery,
      navigate: "/admin/manage/gallery",
    },
    {
      icon: <GenerateReports className={menuIcon} />,
      label: globalVariables.generateReport,
      navigate: "/admin/trial/reports",
    },
    {
      icon: <Magnifier className={menuIcon} />,
      label: globalVariables.trailManagement,
      navigate: "/admin/manage/trial",
    },
    {
      icon: <SwitchRole className="h-6 w-6 mr-3" />,
      label: "Switch-Roles",
      navigate: "/admin/switchRole?option=switchRole",
      active: "/admin/profile?option=switchRole",
    },
    {
      icon: <ManageUsers className={menuIcon} />,
      label: "Database Admin",
      navigate: "/admin/database",
    },
  ];

  const location = useLocation();
  const isDatabaseAdmin = location.pathname.includes('/admin/database');

  return (
    <div>
      {!isDatabaseAdmin && (
        <>
          <div className="hidden lg:block">
            <SideNav menuItems={sideNavData} noProfile={true} />
          </div>
          <div className="lg:hidden">
            <MobileHeader menuItems={sideNavData} noProfile={true} />
          </div>
        </>
      )}
      <Routes>
        <Route path="/dashboard" element={<SuperAdminDashboard />} />
        <Route path="/switchRole" element={<MyProfile />} />
        {/* <Route path="/manange/dogs" element={<h1>Dogs</h1>} />
        <Route path="/manage/users" element={<h1>Users</h1>} /> */}
        <Route path="/payments" element={<Payments />} />
        <Route path="/viewJudges/*" element={<ViewJudges isAdmin={true}/>} />
        <Route path="/viewHosts/*" element={<ViewAllHosts />} />
        <Route path="/manage/dogs" element={<DetailsOfDog />} />
        <Route path="/manage/dogs/addHistory" element={<AddDogHistory />} />
        <Route path="/manage/dogs/editProfile" element={<EditDogProfile />} />
        <Route path="/manage/dogs/dogHistory" element={<AdminDogHistory />} />
        <Route path="/manage/users" element={<ManageUsersScreen />} />
        <Route
          path="/manage/trailEditTrial/*"
          element={<AddTrial isEdit isAdmin />}
        />
        <Route
          path="/manage/users/:id"
          element={
            <RoleTabProvider>
              <UserDetail />
            </RoleTabProvider>
          }
        />
        <Route path="/manage/trial" element={<ManageTrail />} />
        <Route path="/manage/trial/:id" element={<ManageTrailDetails />} />
        <Route
          path="/manage/users/:id/:role/update"
          element={
            <LoaderProvider>
              <EditAbleProfiles />
            </LoaderProvider>
          }
        />
        <Route path="/manage/gallery" element={<ManageGallery />} />
        <Route path="/trial/reports" element={<GenerateReportsScreen />} />
        <Route
          path="/trial/reports/:id"
          element={<ManageTrailDetailsReports />}
        />
        {/* Refine Database Admin */}
        <Route path="/database/*" element={<RefineAdmin />} />
        {/* <Route path="/profile" element={<MyProfile />} /> */}
        <Route path="/" element={<Navigate to="/admin/dashboard" replace />} />
      </Routes>
    </div>
  );
};
